import {IConverage, IDateCreatedExecuted, IProjectSettings, ISelectedElement, ITestResultDisplay, IXTC} from "./Interfaces";
import {Plugin} from "./Main";
import {
    app,
    ControlState,
    ICategoryConfig,
    FieldDescriptions,
    IItem, IStringNumberMap,
    UIToolsConstants,
    IBaseControl,
    IWltItemWithLinks,
    matrixsdk,
    ml, refLinkStyle, refLinkTooltip,
    Tasks,
    IDataStorage, IReference
} from "../../../sdk/client";
import {IDashboardPage, IDashboardParametersBase} from "../../../sdk/plugins/interfaces";
import { Project } from "../../../sdk/objects/Project";
import { Item } from "../../../sdk/objects/Item";
import {DateFieldHandler, DropdownFieldHandler} from "../../../core/common/businesslogic";

interface IDashboardParameters extends IDashboardParametersBase  {
    selection: IReference[];
}
// eslint-disable-next-line no-unused-vars
export class DashboardPage implements IDashboardPage<IDashboardParameters> {
    settings: IProjectSettings;
    _root: JQuery;

    checkForDisplayRequirements(config: ICategoryConfig): string[] {
        let checks = [];
        if (!config) {
            checks.push("No tests configured")
        } else if (config.fieldList == undefined) {
            checks.push("No fields in XTC category")
        } else {
            const xtcFields = config.fieldList;
            if (xtcFields.findIndex((field) => field.fieldType == FieldDescriptions.Field_user) == -1)
                checks.push("No 'user' field defined in XTC category");
            if (xtcFields.findIndex((field) => field.fieldType == FieldDescriptions.Field_date) == -1)
                checks.push("No 'date' field defined in XTC category");
            if (xtcFields.findIndex((field) => field.fieldType == FieldDescriptions.Field_test_result) == -1)
                checks.push("No 'test_result' field defined in XTC category");
        }

        return checks;
    }


    private allLinks: IWltItemWithLinks[] = [];


    overviewGraphChart: c3.ChartAPI;
    overviewPerUserChart: c3.ChartAPI;
    widgetMode: boolean;
    TesterID: number;
    ExecutionDateID: number;
    eventsAttached: boolean;

    private elementsLst: IXTC[] = [];

    constructor(private project: Project, private projectStorage: IDataStorage, private popupModeOrControl = false, private currentFolder: string = undefined) {
        this.settings = {
            ...Plugin.config.projectSettingsPage.defaultSettings,
            ...project.getItemConfig().getSettingJSON(Plugin.config.projectSettingsPage.settingName, {})
        };
    }

    /** Customize static HTML here */
    private getDashboardDOM(): JQuery {
        return $(this.TEOHTMLDom);
    }

    setLastSelection(sel: ISelectedElement[]) {
        sel.forEach(item => item.title = "");
        this.projectStorage.setItem("lastTEOSelection", JSON.stringify(sel));
    }

    public async XTCSelectionChanged(items: ISelectedElement[]) {
        let that = this;

        $(".tasksList").remove();
        $(".ticket-list").remove();
        that.allLinks = [];
        //Remove button event.
        $(".notCoveredItemLink", this._root).unbind();

        if (items == undefined) {
            return;
        }

        if (items == undefined || items.length == 0) {
            $("#TEOContent", that._root).hide();
            $(".spinningWait", that._root).hide();
            return;
        }
        //No save in case of popup
        if (!that.popupModeOrControl && !that.widgetMode)
            that.setLastSelection(items);

        if (that.widgetMode) {
            $(".fillHeight", that._root).removeClass("fillHeight");
            $(".XTCtable", that._root).hide();
        }

        $("#waitForIt", that._root).html("");
        $("#waitForIt", that._root).append(ml.UI.getSpinningWait("please wait..."));
        $("#TEOContent", that._root).hide();
        $("#TEONoItems", that._root).hide();

        $(".spinningWait", that._root).show();

        that.elementsLst = [];
        that.coverage = [];

        $('.addedXtcRow').remove();


        for (let i = 0; i < Tasks.tasksConfiguration.length; i++) {
            let id = Tasks.tasksConfiguration[i].pluginId;
            if (matrixsdk.getProject() != undefined) {
                let result = await new Promise<IWltItemWithLinks[]>(function (resolve, reject) {
                    Tasks.getAllTasksProject(id).then(resolve, reject)
                })
                result.forEach(r => that.allLinks.push(r));
            }
        }

        let deferred: Promise<Item[]>[] = [];

        for (let i = 0; i < that.settings.testResultQueries.length; i++) {
            let d1 = that.getXTCPerStatusInFolder(items, that.settings.testResultQueries[i].mrqlPart);
            d1.then(async (items: Item[]) => {
                let needles = await this.parseNeedleSearch(items, that.settings.testResultQueries[i]);
                that.elementsLst = that.elementsLst.concat(needles);
            });

            deferred.push(d1);
        }

        items.forEach((element: ISelectedElement) => {
            //It's a folder, let's retrieve the items

            if (element.to && element.to[0] == "F") {
                {

                }
            }
            deferred = deferred.concat(that.calculateCoverageByXtc(items));

        });

        // eslint-disable-next-line prefer-spread
        Promise.all(deferred).then(() => {
        // $.when.apply($, deferred).then(function () {
            if (that.elementsLst.length > 0) {
                if (!that.widgetMode)
                    that.renderXTCTable(that.elementsLst);

                $("#TEOContent", this._root).show();
                that.drawXTCCharts(that.elementsLst);
                if (!that.widgetMode)
                    that.renderCoverage();


                let data = that.buildRundownTable(that.elementsLst);
                that.drawCumulativeChart(data);


                $(".spinningWait", this._root).hide();

                let redraw = () => {
                    that.drawXTCCharts(that.elementsLst)
                    that.drawCumulativeChart(data);

                };
                if (!that.eventsAttached) {
                    $(document).on("chartResize", redraw);
                    $(document).on("contextFrameResized", redraw);
                    $(document).on("sidebarResized", redraw);
                    that.eventsAttached = true;
                }

                $("#customStats").html("");
                if (that.settings.otherFields && that.settings.otherFields.length) {
                    let row = $(`<div class="row"> `);
                    let idx = 0;
                    for (let other of that.settings.otherFields) {
                        if (idx % 2 == 0) {
                            row = $(`<div class="row"> `).appendTo($("#customStats"));
                        }
                        idx++;
                        let fid = that.project.getItemConfig().getFieldId("XTC", other);
                        if (fid) that.addOtherStats(row, other, fid);
                    }
                }
            } else {
                $(".spinningWait", this._root).hide();
                $("#TEONoItems", this._root).show();

            }
        });


    }

    private addOtherStats(row: JQuery, fieldName: string, fieldId: number) {

        let col = $(`<div class="col-lg-6">`).appendTo(row);
        let panel = $(`<div class="panel panel-default">`).appendTo(col);
        $(`<div class="panel-heading"><h3 class="panel-title">${fieldName}</h3></div>`).appendTo(panel);
        let panelBody = $(`<div class="panel-body">`).appendTo(panel);


        let stats: IStringNumberMap = {};
        for (let xtc of this.elementsLst) {
            let v = (<any>xtc)["f" + fieldId];
            if (!stats[v]) stats[v] = 1; else stats[v]++;
        }
        let table = $("<table class='table table-bordered'>").appendTo(panelBody);
        let body = $("<tbody>").appendTo(table);
        for (let key of Object.keys(stats)) {
            body.append(`<tr><td>${key == "undefined" ? "not set" : key}</td><td>${stats[key]}</td></tr>`);
        }

    }

    addToolbarButtons() {
        let that = this;

        let toolbarContainer = $(".addedTitle .toolbarButtons", app.itemForm);
        if( toolbarContainer.length == 0)
            toolbarContainer = $("<div class='btn-group toolbarButtons'></div>")
        toolbarContainer.html("");

        // Add toggle button to display task (or not)
        let showTaskGroup = $("<div class='' ></div>");
        let refreshGroup = showTaskGroup.clone();

        refreshGroup.append("<button class='btn btn-item btn-sm' ><span class='fal fa-sync'></span></button>").click(() => {
            that.XTCSelectionChanged(that.getLastSelection());
        });

        showTaskGroup.append($(`<input  type="checkbox" id="showTasks" class="baseControl" style="margin-right: 3px; margin-top:7px;">`).change((evt) => {
            if ($(evt.target).is(':checked'))
                $(".tasksList").show();
            else
                $(".tasksList").hide();
        }));
        showTaskGroup.append($("<small style='line-height:28px;'> Show tasks </small>"));

        toolbarContainer.append(showTaskGroup);
        toolbarContainer.append(refreshGroup);


        if (this.popupModeOrControl) {
            toolbarContainer.css("right", "53px");
            toolbarContainer.appendTo(".ui-dialog-title");
            $("button", refreshGroup).css("font-size", "12px");
        }
        if (this.settings.includeTasksInTable) {
            $("#showTasks").attr("checked", "true");
        }


    }

    renderTeo():JQuery{
        const config = this.project.getItemConfig().getItemConfiguration("XTC");
        let errors = this.checkForDisplayRequirements(config);
        if (errors.length > 0) {
            // We explain why TEO cannot be displayed
            this._root = $("<div>");
            this._root.append(`<p style="padding: 5px;">
                                    TEO cannot be displayed :
                                     <ul>${errors.map(e => `<li>${e}</li>`).join("\n")}</ul>
                                </p>`);
            return this._root;
        }

        this._root = this.getDashboardDOM();
        config.fieldList.forEach(field => {

            if (field.fieldType == FieldDescriptions.Field_user) {
                this.TesterID = field.id;
            }
            if (field.fieldType == FieldDescriptions.Field_date) {
                this.ExecutionDateID = field.id;
            }
        });
        $("#TEOContent", this._root).hide();

        let parameters = {
            prefix: "Include the following folder:",
            buttonName: "Select Test execution items/folder(s)",
            showOnly: ["XTC"],
            singleFolderOnly: false,

        }

        let baseControl = $("#itemSelectionTeo", this._root).itemSelection({
            valueChanged: async () => {
                let title = $("#itemSelectionTeo .itemSelectionList", this._root).text();
                if (title != undefined)
                    title = "Test Execution Overview for " + title.replace(parameters.prefix, "");
                else
                    title = "Test Execution Overview"
                this.installCopyButtons(title);
                let v = await baseControl.getController().getValueAsync();
                let items = JSON.parse(v);
                if (items != undefined) {
                    this.addToolbarButtons();
                    this.XTCSelectionChanged(items);

                }
            }, canEdit: true, controlState: ControlState.FormEdit, help: "", parameter: parameters
        });

        this.itemSelector = baseControl.getController();

        if (this.popupModeOrControl) {
            baseControl.hide();
        }
        //Table filter
        $("#TEOInputFilter", this._root).on("keyup", function (e) {
            let value = $(e.target).val().toLowerCase();
            $("#xtcList tr", this._root).each(function (index, elem) {
                $(elem).toggle($(elem).text().toLowerCase().indexOf(value) > -1)
            });
        });


        if (!this.popupModeOrControl && !this.widgetMode) {
            setTimeout((o: any) => this.start(), 10);
        }
        return  this._root;
    }

    /** Add interactive element in this function */
    renderProjectPage() {

        app.itemForm.append(
            ml.UI.getPageTitle(
                Plugin.config.dashboard.title,
                () => {
                    return this._root;
                },
                () => {
                    this.onResize();
                }
            )
        );


        app.itemForm.append(this.renderTeo());




    }

    installCopyButtons(title: string) {
        let that = this;
        $("#TEOTableHeader i", this._root).remove();

        let savedWidth = 0;


        ml.UI.copyBuffer($("#TEOTableHeader", this._root), "copy list to clipboard", $("#testList", this._root), this._root, (copied: JQuery) => {
            $(".doNotCopy", copied).remove();

            let filter = $("#TEOInputFilter", this._root).val();
            // Different if popup/Control mode
            $(".hidden", copied).remove();


            $("[data-attr='id']", copied).each((i, item) => {
                $(item).text($(item).data("ref") + "!")
            });


            $("#TEOInputFilter", copied).remove();

            $("#TEOTitleForCopy", copied).html("<div><h1>" + title + "</h1> <span> <b> Date:</b> " + ml.UI.DateTime.renderCustomerHumanDate(new Date()) + "</span> <br/>" + (filter != "" ? "<b>Filter : </b>" + filter + "<br/>" : "") + "</div>");
        });

        $("#TEOPieChartTitle i", this._root).remove();

        ml.UI.copyBuffer($("#TEOPieChartTitle", this._root), "copy  to clipboard", $(".panel-body:has(#overviewGraph)"), this._root, (copied: JQuery) => {
            $(".copyTitle", copied).html(`<h1> ${title}</h1><span> <b> Date:</b> ${ml.UI.DateTime.renderCustomerHumanDate(new Date())}</span>`);

            ml.UI.fixC3ForCopy(copied);

        }, "", () => {
            savedWidth = $("#overviewGraph svg", this._root).width();
            that.overviewGraphChart.resize({width: 590});
        }, () => {
            that.overviewGraphChart.resize({width: savedWidth})

        });

        $("#TEOBarChartTitle i", this._root).remove();
        ml.UI.copyBuffer($("#TEOBarChartTitle", this._root), "copy  to clipboard", $(".panel-body:has(#overviewPerUser)"), this._root, (copied: JQuery) => {
            $(".copyTitle", copied).html(`<h1> ${title}</h1><span> <b> Date:</b> ${ml.UI.DateTime.renderCustomerHumanDate(new Date())}</span>`);
            ml.UI.fixC3ForCopy(copied);
        }, "", () => {
            savedWidth = $("#overviewPerUser svg", this._root).width();
            that.overviewPerUserChart.resize({width: 590});
        }, () => {
            that.overviewPerUserChart.resize({width: savedWidth})

        });


    }

    private drawXTCCharts(inputData: IXTC[]) {


        let that = this;
        let columns: any[] = [];

        //Pie color :
        let pieColor: any
        for (let i = 0; i < that.settings.testResultQueries.length; i++) {
            let r = that.settings.testResultQueries[i];
            columns.push([r.displayString, inputData.filter(function (elem) {
                return elem.itrd.mrqlPart == r.mrqlPart
            }).length, r.color]);
        }

        that.overviewGraphChart = c3.generate({
            bindto: '#overviewGraph',
            data: {
                columns: columns,
                type: "donut",
                onclick: function (d, i) {
                    let lastParenthesisIndex = d.id.lastIndexOf("(");
                    let id = lastParenthesisIndex > 0 ? d.id.substring(0, lastParenthesisIndex - 1) : d.id;
                    that.filterXTCByUserByStatus({status: id, user: ""});
                },
                color: function (color, d: string) {
                    let c = columns.filter((item) => {
                        return item[0] == d
                    });
                    if (c.length > 0) {
                        return c[0][c[0].length - 1];
                    }
                    return color;
                },
            },
            donut: {
                label: {
                    format: function (value, ratio, id) {
                        return (value);
                    }
                }

            },
            legend:
                {
                    position: 'inset',
                    inset: {

                        anchor: "top-right"
                    }
                },
            tooltip: {
                format: {
                    value: function (value: any, ratio: any, id: any, index: any) {
                        return value;
                    }
                }
            }


        });

        $("#overviewGraph .c3-event-rect", this._root).click(function () {
            that.filterXTCByUserByStatus({status: "", user: ""});
        });

        let convertedData: Array<Record<string, c3.Primitive>> = [];
        let colors: { [key: string]: string } = {};


        // get User list
        let mySet = inputData.map(x => x.tester);

        let users = [];
        for (let i = 0; i < mySet.length; i++) {
            if (users.indexOf(mySet[i]) < 0) {
                users.push(mySet[i]);
            }
        }
        let groups = that.settings.testResultQueries.map((o) => {
            colors[o.displayString] = o.color;
            return o.displayString

        });
        //let usersData = [["User", "Passed", "Failed", "New", "Progress", { role: 'annotation' }]]
        for (let i = 0; i < users.length; i++) {
            let user = users[i];
            let line: Record<string, c3.Primitive> = {"tester": user};
            for (let j = 0; j < that.settings.testResultQueries.length; j++) {
                let r = that.settings.testResultQueries[j];
                line[r.displayString] = inputData.filter(function (elem) {
                    return elem.tester == user && elem.itrd.displayString == r.displayString
                }).length;
            }
            convertedData.push(line);
        }

        //Calculate width
        let containerWidth = $("#overviewPerUser", this._root).width();

        let itemWidth = containerWidth / 15;

        let graphWidth = -1;

        if (users.length > 15) {
            graphWidth = itemWidth * (users.length + 1);
            $("#overviewPerUser", this._root).css("overflow-x", "auto");
            $("#overviewPerUser", this._root).css("overflow-y", "hidden");
        }

        that.overviewPerUserChart = c3.generate({
            bindto: '#overviewPerUser',
            size: {
                width: graphWidth != -1 ? graphWidth : undefined,
            },
            data: {
                json: convertedData,
                keys: {
                    x: 'tester', // it's possible to specify 'x' when category axis
                    value: groups,
                },
                type: "bar",
                groups: [groups],
                colors: colors,
                onclick: function (d, element) {
                    that.filterXTCByUserByStatus({status: d.id, user: convertedData[d.index].tester});
                }
            },
            axis: {
                x: {
                    type: 'category',
                    tick: {
                        fit: true,
                        rotate: 45,
                        multiline: false,
                        multilineMax: 1

                    }
                },
            },
            legend:
                {
                    position: 'inset',
                    inset: {
                        anchor: graphWidth == -1 ? "top-right" : "top-left"
                    }
                },
            zoom: {
                enabled: false,
                rescale: false,
                extent: [1, 5]
            }
        });
        return;
    }

    private drawCumulativeChart(lst: IDateCreatedExecuted): any {

        let date: any[] = ["Date"];
        let created: any[] = ["Created"];
        let todos: any[] = ["Todos"];

        for (let key in lst) {
            let value = lst[key];
            date.push(value.date);
            created.push(value.created);
            todos.push(value.todos);
        }

        c3.generate(
            {
                bindto: '#cumulativeChart',
                data: {
                    columns: <Array<[string, ...c3.PrimitiveArray]>>[date, created, todos],
                    x: "Date",
                    type: "step"
                },
                axis: {
                    x: {
                        type: 'timeseries',
                        tick: {
                            format: '%Y-%m-%d',
                            count: 10,
                            fit: true

                        }
                    }
                },
                point: {
                    show: false
                },
                zoom: {
                    enabled: false,
                }

            }
        )
        return;


    }

    start() {
        let that = this;

        // No automatic start in case of popup
        if (that.popupModeOrControl)
            return;
        // Get last opened XTC for that user.

        let items = that.getLastSelection();
        if (items != undefined) {
            that.itemSelector.setValue(items.map((o: any) => o.to));
        }

    }

    getLastSelection(): ISelectedElement[] {

        if( this.currentFolder )
            return [{to: this.currentFolder , title:""}];

        let value = this.projectStorage.getItem("lastTEOSelection");
        if (value != undefined && value != "")
            return JSON.parse(value);
        return undefined;

    }

    buildRundownTable(lst: IXTC[]): IDateCreatedExecuted {
        let that = this;
        let dates = lst.map((item) => {
            return item.creationDate
        });
        dates = dates.concat(lst.map((item) => {
            return item.executionDate;
        }));
        let mapDates = dates.map((item) => {
            return moment([item.year(), item.month(), item.date()])
        }).filter((m) => {
            return m.isValid()
        });
        let filterMapDates: IDateCreatedExecuted = {};
        for (let index = 0; index < mapDates.length; index++) {
            let dateAsNumber = parseInt(mapDates[index].format("YYYYMMDD"));
            filterMapDates[dateAsNumber] = {date: mapDates[index].toDate(), created: 0, todos: 0}
        }


        for (let key in filterMapDates) {
            let keyAsInt = parseInt(key);
            let nbCreated = lst.filter((element) => {
                let d = parseInt(element.creationDate.format("YYYYMMDD"));
                return (d <= keyAsInt)
            }).length;
            let nbExecuted = lst.filter((element) => {
                let d = 0;
                if (element.executionDate != undefined) {
                    d = parseInt(element.executionDate.format("YYYYMMDD"));
                }
                return ((that.settings.executedStatusForRunDown.indexOf(element.itrd.mrqlPart) != -1) && (d <= keyAsInt));
            }).length;
            filterMapDates[key].created = nbCreated;
            filterMapDates[key].todos = nbCreated - nbExecuted;
        }
        return filterMapDates;
    }

    renderCoverage(): any {

        let that = this;
        let covered = 0;
        let notCovered = 0;
        this.coverage.forEach((cover) => {
            if (cover.covered) {
                covered += cover.items.length;
            } else {
                notCovered += cover.items.length;
            }
        });
        $(".coveredCount", this._root).html(covered.toString());
        $(".notCoveredCount", this._root).html(notCovered.toString());

        $(document).ready(() => {
            let total = covered + notCovered;

            $('.covered .progress-bar', that._root).css("width", (covered / total) * 100 + "%");
            $('.covered .progress-bar', that._root).prop("aria-valuenow", (covered / total) * 100 + "%");

            $(".covered .progress-bar[role=progressbar]", this._root).css("background", UIToolsConstants.CIColors.GreenSushi.color);
            $(".covered .progress-bar[role=progressbar]", this._root).parent().css("background", UIToolsConstants.CIColors.OrangeYellow.color);
        });

        $(".notCoveredItemLink", this._root).click((e) => {

            e.preventDefault();
            let dlg = $("<div id='notCoveredItemDlg'>").appendTo($("#TEOContent", that._root));
            let ui = $("<div style='height:100%;width:100%'>");

            let table = ui.append("<table><tr><th>Items</th></tr>");
            that.coverage.filter((o) => {
                return !o.covered
            }).forEach(item => {

                item.items.forEach(element => {
                    let id = element.getId();
                    let jId = $("<span>").refLink({
                        id: id,
                        title: element.getTitle(),
                        style: refLinkStyle.link,
                        tooltip: this.widgetMode ? refLinkTooltip.none : refLinkTooltip.html,
                        hideTitle: false,
                        crossProject: that.project.getName()
                    });

                    let line = $(`<tr>
                                    <td class="refId"></td>
                                    </tr>`);
                    $(".refId", line).append(jId);
                    table.append(line);

                });


            });

            let dialogTitle = "Items not covered by selected XTCs";

            ml.UI.showDialog(dlg, dialogTitle, ui, 600, 600,
                [{
                    text: 'OK',
                    class: 'btnDoIt',
                    click: function () {
                        dlg.dialog("close");
                    }
                }],
                UIToolsConstants.Scroll.Vertical,
                true,
                true,
                () => {
                    dlg.remove();
                },
                () => {

                },
                () => {
                }
            );

        });


    }

    renderXTCTable(lst: IXTC[]) {
        let that = this;
        $('.addedXtcRow', this._root).remove();

        for (let i = 0; i < lst.length; i++) {
            let xtc = lst[i];
            let template = $("#xtcRow", this._root).clone();
            let itemId = xtc.id ;
            let link = $("<div></div>").refLink({
                id: itemId,
                title: xtc.title,
                style: refLinkStyle.link,
                tooltip: refLinkTooltip.html,
                hideTitle: false,
                crossProject: that.project.getName()
            })
            template.find("[data-attr='id']").append(link);
            template.find("[data-attr='id']").data("ref", itemId);
            template.find("[data-attr='result']").html(xtc.itrd.displayString);
            template.find(".square").css("background-color", xtc.itrd.color);
            template.find("[data-attr='tester']").html("");
            template.find("[data-attr='tester']").append(ml.UI.getAvatar(xtc.tester, 24));//+ " --> " + xtc.creationDate.format("YYYYMMDD") + "|" + xtc.executionDate.format("YYYYMMDD"));
            template.find("[data-attr='tester']").append($("<span style='margin-left:10px' >" + xtc.tester + "</span>"));//+ " --> " + xtc.creationDate.format("YYYYMMDD") + "|" + xtc.executionDate.format("YYYYMMDD"));

            if (that.allLinks.length > 0) {
                //find all links for that item
                let links = that.allLinks.filter((al => al.matrixItem.matrixItem == itemId));
                let itemLinks = [];
                for (let ii = 0; ii < links.length; ii++) {
                    links[ii].links.forEach(l => itemLinks.push(l));
                }

                if (itemLinks.length > 0) {
                    let div = $("<div style='font-size:10px;' class='tasksList' ></div>");
                    Tasks.renderTasks(itemId, itemLinks, div, false, false);
                    let showTasks = $("#showTasks").is(":checked")
                    if (!showTasks)
                        div.hide();
                    template.find("[data-attr='id']").append(div);
                }
            }


            template.removeClass("hidden");
            template.addClass("addedXtcRow")
            $('#xtcList').append(template);
        }
        if (lst.length == 0) {
            $('#xtcList').append('<tr class="addedXtcRow" class="hidden"> <td colspan="4"> No data to display</td></tr>');

        }


    }

    filterXTCByUserByStatus(filter: any) {
        let that = this;
        if (filter == undefined) {
            that.renderXTCTable(that.elementsLst);
        } else {
            let elementToDisplay = that.elementsLst;
            if (filter.user != "") {
                elementToDisplay = elementToDisplay.filter((o: any) => {
                    return o.tester == filter.user
                });

            }
            if (filter.status != "") {
                elementToDisplay = elementToDisplay.filter((o: any) => {
                    return o.itrd.displayString == filter.status
                });
            }
            that.renderXTCTable(elementToDisplay);
        }
    }


    async getXTCPerStatusInFolder(items: ISelectedElement[], mrqlPart: string): Promise<Item[]> {
        let that = this;
        let itemsQueryParts = items.map((item) => {
            if (item.to && item.to[0] === 'F') {
                return " folderm =  " + item.to;
            } else {
                return " id = " + item.to;

            }
        });
        // define which fields to get: at least tester and date
        const xtcCat = this.project.getCategory("XTC");
        let fieldIds = [that.TesterID, that.ExecutionDateID];
        if (this.settings.otherFields && this.settings.otherFields.length) {
            for (let other of this.settings.otherFields) {
                const res = xtcCat.getFieldIdFromLabel(other);
                if (res.length >= 1 && fieldIds.indexOf(res[0]) == -1) {
                    fieldIds.push(res[0]);
                }
            }
        }
        //MATRIX-6319 : safeguard against url encoded characters (e.g. %20  for space or %22 for quotes).
        // Old settings might contain that.
        //Let's search for % then 2 digits using regex
        let regex = /%[0-9][0-9]/g;
        let match = mrqlPart.match(regex);
        if(match != null){
            //contains" url encoded characters
            mrqlPart = decodeURI(mrqlPart);
        }

        const mrql = `mrql:(${itemsQueryParts.join(' or ')}) and (${mrqlPart})`;
        let mask = this.project.constructSearchFieldMask();
        mask.addMask(xtcCat, fieldIds);
        let labelFilter = ml.LabelTools.getFilter();

        return this.project.searchForItems(mrql, labelFilter, true, mask);
    }

    async parseNeedleSearch(results: Item[], itrd: ITestResultDisplay): Promise<IXTC[]> {
        let that = this;
        let lst: IXTC[] = [];
        if (results != undefined) {
            for (const e of results) {
                let xtc: IXTC = await that.getXTCFromNeedleResult(e, itrd);
                lst.push(xtc);
            }
        }
        return lst;
    }

    private async getXTCFromNeedleResult(e: Item, itrd: ITestResultDisplay): Promise<IXTC> {
        let that = this;
        let format = ml.UI.DateTime.getSimpleDateTimeFormatMoment();
        let tester = e.getFieldById(that.TesterID).getHandler<DropdownFieldHandler>().getData();

        let xtc: IXTC = {
            id: e.getId(),
            title: e.getTitle(),
            itrd: itrd,
            creationDate: moment(e.getCreationDate(), format),
            tester: tester ? tester :  "unassigned",
            executionDate: moment((await e.getFieldById(that.ExecutionDateID).getHandler<DateFieldHandler>().getDate() ) ??  undefined , format)
        };
        //Handle the imported project...
        if (xtc.creationDate > xtc.executionDate) {
            xtc.creationDate = xtc.executionDate;
        }
        // handle other fields
        const xtcCat = this.project.getCategory("XTC");
        if (this.settings.otherFields && this.settings.otherFields.length) {
            for (let other of this.settings.otherFields) {
                const res = xtcCat.getFieldIdFromLabel(other);
                if (res.length >= 1) {
                    (<any>xtc)["f" + res[0]] = await that.getFieldValue(res[0], e, "undefined");
                }
            }
        }
        return xtc;
    }

    private async getFieldValue(id: number, e: Item, replacementValue = ""): Promise<string> {
        let result = "";
        const field = e.getFieldById(id);
        let fieldVal = field.getHandlerRaw().getData();
        if (fieldVal != undefined) {
            result = fieldVal;
        }
        if (result === "") {
            result = replacementValue;
        }
        return result;
    }

    private itemSelector: IBaseControl;

    coverage: IConverage[] = [];

    calculateCoverageByXtc(selectedElements: ISelectedElement[]): Promise<Item[]>[] {
        let that = this;
        let deffered: Promise<Item[]>[] = [];

        // Define a complex query
        let mrql = "";
        let folderQueryPart = "";
        let notQuery = "";
        {
            folderQueryPart = selectedElements.map(f => `downlinkM= ${f.to}`).join(" OR ");

            const rules = that.project.getItemConfig().getTraceConfig().rules;

            notQuery = "not(";
            notQuery += rules.filter(item => item.end_point != "XTC")
                .map(item => "category=" + item.category)
                .join(" OR ");
            notQuery += " OR category = XTC)";

            const optionalCoverageGroundTruthPart =
                (this.settings.coverageGroundTruthMrqlPart && this.settings.coverageGroundTruthMrqlPart.length > 0)
                    ? " AND (" + this.settings.coverageGroundTruthMrqlPart + ")"
                    : "";
            mrql = `mrql:${folderQueryPart}${optionalCoverageGroundTruthPart}`;
        }
        const labelFilter = ml.LabelTools.getFilter();

        // We don't need any fields.
        const mask = that.project.constructSearchFieldMask({ includeFields: false, includeLabels: false });
        const result1 = that.project.searchForItems(mrql, labelFilter, true, mask);
        deffered.push(result1);
        result1.then((items: Item[]) => {
            that.coverage.push({ selectedElements: selectedElements, items: items, covered: true, query: mrql });
        });

        const otherCoverageGroundTruthPart = this.settings.coverageGroundTruthMrqlPart
            ? ` AND ( ${this.settings.coverageGroundTruthMrqlPart} )`
            : "";
        const mrql2 = `mrql:not(${folderQueryPart}) AND ${notQuery}${otherCoverageGroundTruthPart}`;
        const result2 = that.project.searchForItems(mrql2, labelFilter, true, mask);
        deffered.push(result2);
        result2.then((items: Item[]) => {
            that.coverage.push({
                selectedElements: selectedElements,
                items: items,
                covered: false,
                query: mrql2
            });
        });

        return deffered;
    }


    onResize() {
        /* Will be triggered when resizing. */
    }

    private TEOHTMLDom = `

         <div class="panel-body-v-scroll fillHeight panel-default ">
        <style>
        .chart {
            width: 90%;
            min-height: 350px;
            cursor:pointer;
        }
        .bigChart
        {
            min-height:600px;
        }
        </style>


        <div  style="margin:10px;">
            <div class="row product doNotCopy">
                <div id="itemSelectionTeo" class="col-lg-12 col-md-5 col-md-offset-0"></div>
            </div>
            <div class="row" id="waitForIt" class="spinningWait">

            </div>
            <div id="TEONoItems">Not enough data to display Test Execution Overview </div>
        </div>
        <div id="TEOContent" class="" style="margin:10px;" >
            <div class="row doNotCopy coverage">
                <div class="col-lg-12 ">
                      <div class="panel panel-default">
                        <div class="panel-heading">
                             <h3 class="panel-title">Items covered by selected XTC folder</h3>
                        </div>
                      <div class="panel-body">
                        <div class="row ">
                            <div class="col-lg-6 covered">
                                <div class="progress-bar-xs progress">
                                    <div class="progress-bar progress-bar-success"  role="progressbar" aria-valuenow="71" aria-valuemin="0"
                                        aria-valuemax="100" style="width: 71%;">
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 covered">
                                <span class="coveredCount">212</span> items covered and <span class="notCoveredCount"></span> items not covered by selected XTCs. <a href="#" class="notCoveredItemLink ">Display not covered items...</a>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="row doNotCopy">
                <div class="col-lg-6 ">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h3 class="panel-title" id="TEOPieChartTitle">Overview</h3>
                        </div>
                        <div class="panel-body">
                            <div class='copyTitle'> </div>
                            <div id="overviewGraph" class="chart"></div>
                        </div>
                    </div>
                </div>
                <div  class="col-lg-6">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h3 class="panel-title" id="TEOBarChartTitle">Overview per user</h3>
                        </div>
                        <div class="panel-body">
                            <div class='copyTitle'> </div>
                            <div id="overviewPerUser" class="chart" ></div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="testList">
            <div class="row" id="TEOTitleForCopy">
            </div>
                <div class="row doNotCopy XTCtable">
                    <div class="col-lg-3 ">
                        <h3 id="TEOTableHeader">Test execution list</h3>
                    </div>
                    <div class=" col-lg-7">
                    </div>
                    <div class=" col-lg-2">
                    <input type="text" id="TEOInputFilter" style="margin-bottom:10px;" placeholder="filter..." class="doNotCopy  form-control"></input>
                </div>
                </div>
                    <div class="row XTCtable">
                        <div class="col-md-12">

                        <div class="table-responsive">
                                <table class="table table-condensed table-borderless table-hover" id="TEOTable">
                                    <thead>
                                        <tr>
                                           <th style="width: 110px;">Status</th>
                                            <th style="">XTC</th>
                                            <th>Tester</th>
                                        </tr>
                                    </thead>
                                    <tbody id="xtcList">

                                        <tr id="xtcRow" class="hidden">
                                            <td data-attr="icon" style="display:flex;">
                                                  <div class="square" style="height: 14px;width: 14px;margin-right: 3px;border-radius: 4px;margin-top: 2px;"> </div>
                                                  <small data-attr='result'> </small>
                                            </td>
                                            <td data-attr="id" style=""></td>
                                            <td data-attr="tester">Francois</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                    <div class="row doNotCopy">
                        <div class="col-lg-12">
                                <div class="panel panel-default">
                                    <div class="panel-heading">
                                            <h3 class="panel-title">Count per day</h3>
                                    </div>
                                    <div class="panel-body">
                                        <div id="cumulativeChart" class="chart bigChart"></div>
                                    </div>
                                </div>
                        </div>
                    </div>
                <div id="customStats"></div>
            </div>
        </div>
        <style>
        .taskStatus{

        }
        </style>
        `
}
